import type { Vec2 } from './types';

/** Input state lives on simulation time; rendering/hit-stop never owns input. */
export class CombatRhythm {
  held = false;
  buffered = 0;
  recovery = 0;
  hurt = 0;
  dodge = 0;
  dodgeDirection: Vec2 = { x: 1, y: 0 };
  charges = 2;
  refill = 0;
  counter = 0;
  charging = false;
  charge = 0;
  tick(dt: number): void {
    this.buffered = Math.max(0, this.buffered - dt);
    this.recovery = Math.max(0, this.recovery - dt);
    this.hurt = Math.max(0, this.hurt - dt);
    this.dodge = Math.max(0, this.dodge - dt);
    this.counter = Math.max(0, this.counter - dt);
    if (this.charging) this.charge = Math.min(0.8, this.charge + dt);
    if (this.charges < 2) {
      this.refill += dt;
      if (this.refill >= 1.25) { this.charges += 1; this.refill -= 1.25; }
    } else this.refill = 0;
  }
  requestSlash(): void { this.buffered = 0.2; }
  get canSlash(): boolean { return this.recovery === 0 && this.hurt === 0 && this.dodge < 0.045 && !this.charging; }
  beginDodge(direction: Vec2): boolean {
    if (this.charges <= 0 || this.dodge > 0.045) return false;
    this.charges -= 1;
    this.dodgeDirection = direction;
    this.dodge = 0.18;
    this.recovery = 0.1;
    this.hurt = 0;
    this.charging = false;
    this.charge = 0;
    return true;
  }
  release(): void { this.held = false; this.buffered = 0; this.charging = false; this.charge = 0; }
}

export function fanDirection(direction: Vec2, id: number): Vec2 {
  const angle = Math.atan2(direction.y, direction.x) + ((id % 7) - 3) * 0.065;
  return { x: Math.cos(angle), y: Math.sin(angle) };
}
